import axios from 'axios';
import { apiBaseUrl } from 'App';
import { getCsrfToken } from 'services/authentication/csrfFunctions';

// Fetches a public knowledge base endpoint, the session cookie is sent when present
export const fetchPublicKnowledgeBase = async <T,>(path: string, params?: Record<string, any>): Promise<T> => {
    const response = await axios({
        url: `${apiBaseUrl}/${path}/`,
        method: 'get',
        params,
        withCredentials: true,
        headers: { 'X-CSRFToken': getCsrfToken() },
    });
    return response.data as T;
};

// Posts to a public knowledge base endpoint, the csrf token is only sent when the browser has one
export const postPublicKnowledgeBase = async <T,>(path: string, data: Record<string, any>): Promise<T> => {
    const csrfToken = getCsrfToken();
    const response = await axios({
        url: `${apiBaseUrl}/${path}/`,
        method: 'post',
        data,
        withCredentials: true,
        headers: csrfToken ? { 'X-CSRFToken': csrfToken } : {},
    });
    return response.data as T;
};
